import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { default as AsyncReactSelect, Props as ReactSelectProps } from "react-select/lib/Async";

import { getReactSelectStyles } from "../constants";
import { DefaultOption } from "../Select";
import { messages } from "../messages";

interface AsyncSelectProps<T = DefaultOption> extends ReactSelectProps<T> {
    placeholderMessage?: MessageDescriptor;
}

type Props<T> = AsyncSelectProps<T>;

const AsyncSelect = <T extends unknown>(props: Props<T>) => {
    const { placeholderMessage } = props;
    const { formatMessage } = useIntl();
    const translations = {
        noOptionsMessage: () => formatMessage(messages.selectNoResults),
        loadingMessage: () => formatMessage(messages.selectLoading),
        placeholder: formatMessage(
            placeholderMessage != null ? placeholderMessage : messages.selectPlaceholderLabel,
        ),
    };

    return (
        <AsyncReactSelect
            classNamePrefix="react-select"
            styles={getReactSelectStyles()}
            {...translations}
            {...props}
        />
    );
};

type DefaultAsyncSelect = typeof AsyncSelect<DefaultOption>;
const DefaultAsyncSelect = AsyncSelect as DefaultAsyncSelect;

export {
    AsyncSelect,
    AsyncSelectProps,
};
